/*
 * 商品列表module
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 20:20:31
 * @Last Modified by: zhiwei.luo@zuolin.com.com
 * @Last Modified time: 2021-01-25 16:13:47
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const CommodityHome = Loadable({
	loader: () => import('./routes/commodity-home'),
	loading: Spin,
});

const CommodityDetail = Loadable({
	loader: () => import('./routes/commodity-detail'),
	loading: Spin,
});

const CommodityEdit = Loadable({
	loader: () => import('./routes/commodity-edit'),
	loading: Spin,
});

const CommodityQrCode = Loadable({
	loader: () => import('./routes/commodity-qrcode'),
	loading: Spin,
});

const CommodityApplyList = Loadable({
	loader: () => import('./routes/commodity-applyList'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route path={`${match.url}/edit/:id`} component={CommodityEdit} />
			<Route path={`${match.url}/detail/:id`} component={CommodityDetail} />
			<Route path={`${match.url}/qrCode`} component={CommodityQrCode} />
			<Route path={`${match.url}/applyList/edit/:censorNo`} component={CommodityEdit} />
			<Route path={`${match.url}/applyList/detail/:censorNo`} component={CommodityDetail} />
			<Route exact path={`${match.url}/applyList`} component={CommodityApplyList} />
		  <Route path={`${match.url}/add`} component={CommodityEdit} />
			<Route path={match.url} component={CommodityHome} />
		</Switch>
	);
};
